export enum SettingEnum {
  USDC_TOKEN_ADDRESS = 'usdc_token_address',
  MEY_TOKEN_ADDRESS = 'mey_token_address',
  MARKETPLACE_CONTRACT = 'marketplace_contract',
  P2P_SUM_TRANSACTION_CONTRACT = 'p2p_sum_transaction_contract',
  PTO_DEPOSIT_TOKEN_ADDRESS = 'pto_deposit_token_address',
  PTO_SUM_TRANSACTION_CONTRACT = 'pto_sum_transaction_contract',
  STAKE_TIER_MANAGER_CONTRACT = 'stake_tier_manager_contract',
  STAKE_TOKEN_ADDRESS = 'stake_token_address',
  STAKE_NFT_ADDRESS = 'stake_nft_address',
  STAKE_NFT_ADDRESS_MEY = 'stake_nft_address_mey',
  USER_HOLD_MEY_TOKEN_CONTRACT = 'user_hold_mey_token_contract',
  USER_VESTING_HMC_MAY_CONTRACT = 'user_vesting_hmc_may_contract',
  USER_VESTING_MAY_CONTRACT = 'user_vesting_may_contract',
  USER_VESTING_VENTURES_MAY_CONTRACT = 'user_vesting_ventures_may_contract',
  PTO_FACTORY_CONTRACT = 'pto_factory_address',
  PTO_FACTORY_V2_CONTRACT = 'pto_factory_v2_address',
  PTO_DISTRIBUTION_CONTRACT = 'pto_distribution_contract_address',
  /** PTOOrchestrator (ERC-3643) - key `pto_orchestrator_address` on the Setting page (contract_info) */
  PTO_ORCHESTRATOR_ADDRESS = 'pto_orchestrator_address',
  RARITY_REWARD_FACTORY_ADDRESS = 'rarity_reward_factory_address',
  DAO_GATEWAY_ADDRESS = 'dao_gateway_address',
  DAO_VOTING_ADDRESS = 'dao_voting_address',
  DAO_ASSET_STATE_MACHINE_ADDRESS = 'dao_asset_state_machine_address',
  DAO_POOL_FACTORY_ADDRESS = 'dao_pool_factory_address',
  /** holds the AssetStateMachine contract address */
  DAO_VOTING_FACTORY_ADDRESS = 'dao_voting_factory_address',
  REVENUE_SHARING_RENTAL_FACTORY_ADDRESS = 'revenue_sharing_rental_factory_address',
  SAFE_VESTING_MULTISIG_ADDRESS = 'safe_vesting_multisig_address',
  STAKE_NFT_MEY_CONTRACT_ADDRESS = 'stake_nft_mey_contract_address',
}
